module.exports = __webpack_public_path__ + "static/media/rolelist.ac346e12.svg";